export default __webpack_public_path__ + "static/media/origami-flamingo.3f2d6580.png";